// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".career-center-company cookie-consent::part(description),.career-center-company cookie-consent::part(title){color:#10001f}.career-center-company cookie-consent::part(btnOkOne){display:none}.career-center-company cookie-consent::part(btnOkTwo){display:block}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
